import React from "react";
import classNames from "classnames";
import { FilterSourceItem, FilterValues } from "./FilterValuesCollection";

interface ProductListSubcategoriesFilterProperties {
    readonly isActive: boolean;
    readonly subcategories: FilterSourceItem[];
    readonly filter: FilterValues;

    readonly onFilterChange: (filter: FilterValues) => void;
    readonly onActivateTab: () => void;
}

export default function ProductListSubcategoriesFilter({
    isActive,
    subcategories,
    filter,
    onFilterChange,
    onActivateTab,
}: ProductListSubcategoriesFilterProperties): React.JSX.Element | undefined {
    if (subcategories.length === 0) {
        return undefined;
    }

    const handleFilterToggle = (subcategoryId: number): void => {
        let currentSubcategories: number[] = filter.Subcategories ?? [];

        if (currentSubcategories.includes(subcategoryId)) {
            currentSubcategories = currentSubcategories.filter((id) => id !== subcategoryId);
        } else {
            currentSubcategories.push(subcategoryId);
        }

        onFilterChange(Object.assign({}, filter, { Subcategories: currentSubcategories }));
    };

    return (
        <div className="filter-widget">
            <h2 className={isActive ? "active" : undefined} onClick={onActivateTab}>Kategorie<i className="fa-solid fa-caret-down"></i></h2>

            <div className={classNames("widget-content", "category-checkbox", { hidden: !isActive })}>
                {subcategories.map((subcategory) => <div className="filter-container" key={subcategory.id}>
                    <label htmlFor={`fp_${subcategory.id}`}>
                        {subcategory.title}
                        <input
                            type="checkbox"
                            id={`fp_${subcategory.id}`}
                            value={subcategory.id}
                            onChange={() => handleFilterToggle(subcategory.id)}
                            checked={filter.Subcategories?.includes(subcategory.id)} />
                        <span className="checkmark"></span>
                        <span> ({subcategory.quantity}&times;)</span>
                    </label>
                </div>)}
            </div>
        </div>
    );
}
